<template>
  <v-container fluid>
    <v-row>
      <v-col cols="11">
        <v-tabs v-model="tab">
          <v-tab>基本情報</v-tab>
          <v-tab>ドメイン関連</v-tab>
          <v-tab>セキュリティ</v-tab>
          <v-tab>SNS</v-tab>
          <v-tab>APIキー</v-tab>
          <v-tab>キャッシュ削除</v-tab>
        </v-tabs>
        <v-tabs-items v-if="siteId" v-model="tab">
          <v-tab-item>
            <basic-form :site-id="siteId" />
          </v-tab-item>
          <v-tab-item>
            <domain-form :site-id="siteId" />
          </v-tab-item>
          <v-tab-item>
            <security-form :site-id="siteId" />
          </v-tab-item>
          <v-tab-item>
            <sns-form :site-id="siteId" />
          </v-tab-item>
          <v-tab-item>
            <api-key-form :site-id="siteId" />
          </v-tab-item>
          <v-tab-item>
            <cache-deletion/>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import BasicForm from './forms/BasicForm'
import DomainForm from './forms/DomainForm'
import SecurityForm from './forms/SecurityForm'
import SnsForm from './forms/SnsForm'
import ApiKeyForm from './forms/ApiKeyForm'
import CacheDeletion from './forms/CacheDeletion'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    ApiKeyForm,
    BasicForm,
    DomainForm,
    SecurityForm,
    SnsForm,
    CacheDeletion
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'サイト設定',
      siteId: null,
      tab: null
    }
  },
  mounted: function () {
    axios.get('/api/site_reference').then(
      ({ data }) => {
        this.siteId = data.data.attributes.id
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: `サイト情報の取得に失敗しました（${error.response.data.errors.toString()}）`
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  }
}
</script>

<style scoped></style>
